export const REQUEST_INTEGRAL_DATA = 'REQUEST_INTEGRAL_DATA'
export const SET_INTEGRAL_DATA = 'SET_INTEGRAL_DATA'
